import { mediaDetailsQuery } from 'utils/queries'

export default async function({ props, path, graphql }) {
  try {
    const result = await graphql.query(mediaDetailsQuery(props.id))

    const data = result.media

    const mediaDetails = {
      ...data,
      resources: data.resources
        ? data.resources.reduce((acc, resource) => {
            acc[resource.type] = resource.values
            return acc
          }, {})
        : null
    }

    return path.loaded({ payload: mediaDetails })
  } catch (e) {
    return path.error(e)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/loadDetails.js